(() => {
  const filterMedia = (mediaEl, variantId) => {
    const vid = String(variantId);
    if (mediaEl.__vgLast === vid) return; // duplicate trigger ignore
    const tagged = mediaEl.querySelectorAll('[data-vg-ids]');
    if (!tagged.length) return;
    const hasMatch = [...tagged].some(el => el.dataset.vgIds.split(';').includes(vid));

    mediaEl.querySelectorAll('.hdt-slider__slide[data-media-id]:not([data-media-type="360-spin"])').forEach(el => {
      const ids = (el.dataset.vgIds || '').split(';');
      el.toggleAttribute('hidden', hasMatch && !ids.includes(vid));
    });

    mediaEl.querySelectorAll('[reval]:not([hidden])').forEach(el => el.removeAttribute('reval'));
    mediaEl.querySelectorAll('.hdt-slider__slide:not([hidden]) img[loading="lazy"]').forEach(i => { i.loading = 'eager'; });

    mediaEl.sliderMain?.reInit?.();
    mediaEl.sliderThumb?.reInit?.();
    mediaEl.__vgLast = vid;
  };

  const readVid = (mediaEl) => {
    const form = document.getElementById(mediaEl.getAttribute('form') || '');
    return form?.querySelector('[name="id"]')?.value;
  };

  const refresh = (vid) => {
    document.querySelectorAll('hdt-product-media').forEach(el => {
      const v = vid || readVid(el);
      if (v) filterMedia(el, v);
    });
  };

  // 1) theme ka custom event (agar fire hota hai to fastest path)
  document.addEventListener('variantChange', (e) => {
    setTimeout(() => refresh(e.detail?.variant?.id), 60);
  }, true);

  // 2) native change — size <select> aur radio swatches bubble karte hain
  document.addEventListener('change', () => setTimeout(() => refresh(), 150), true);

  // 3) URL ?variant= update — button-type swatches ke liye (history hook)
  const hook = (name) => {
    const orig = history[name];
    history[name] = function (...a) { const r = orig.apply(this, a); setTimeout(() => refresh(), 60); return r; };
  };
  hook('replaceState');
  hook('pushState');
  window.addEventListener('popstate', () => setTimeout(() => refresh(), 60));

  // back/forward cache sync
  window.addEventListener('pageshow', () => setTimeout(() => refresh(), 100));
})();